import * as React from 'react'
import { useLocation, Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { updateLastActive } from '../../utils/templatesApi'

const drawerWidth = 240

function SideBar({ role, userId }) {
  const location = useLocation()

  let menuItems = []

  if (role === 'super-admin') {
    menuItems = [
      { text: 'Dashboard', path: '/' },
      { text: 'Templates', path: '/templates' },
      { text: 'Categories', path: '/categories' },
      { text: 'Users', path: '/users' },
      { text: 'Email Validate', path: '/email-validate' },
      { text: 'Reports', path: '/reports' },
      { text: 'AI Email Generate', path: '/ai_email_generate' },
      { text: 'Edit Prompt', path: '/edit_prompt' },



    ]
  } else if (role === 'admin') {
    menuItems = [
      { text: 'Dashboard', path: '/' },
      { text: 'Templates', path: '/templates' },
      { text: 'Email Validate', path: '/email-validate' },
      { text: 'Categories', path: '/categories' },
      { text: 'Users', path: '/users' },
      { text: 'AI Email Generate', path: '/ai_email_generate' },
      { text: 'Edit Prompt', path: '/edit_prompt' },



    ]
  } else {
    menuItems = [
      { text: 'Templates List', path: '/' },
      { text: 'Email Validate', path: '/email-validate' },
      { text: 'AI Email Generate', path: '/ai_email_generate' },


    ]
  }

  const drawer = (
    <div>
      <List>
        {menuItems.map(item => {
          const isActive = location.pathname === item.path

          return (
            <React.Fragment key={item.text}>
              <ListItem disablePadding>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  onClick={() => {
                    updateLastActive(userId, new Date())
                  }}
                  sx={{
                    backgroundColor: isActive ? '#111827' : 'transparent',
                    color: isActive ? 'white' : 'inherit',
                    '&:hover': {
                      backgroundColor: isActive ? '#111827' : 'action.hover',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{ color: isActive ? 'white' : 'inherit' }}
                  ></ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
              <Divider />
            </React.Fragment>
          )
        })}
      </List>
    </div>
  )

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Box
        component='nav'
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label='menu folders'
      >
        <Drawer
          variant='permanent'
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              top: '144px',
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  )
}

export default SideBar
